// extracted by mini-css-extract-plugin
module.exports = {"panicButton":"_e9ed88b"};